import { useOutletContext } from 'react-router-dom';

/**
 * Toasts admin-personnel (pile du layout, même UX que réception / major).
 */
export function useApToast() {
  const ctx = useOutletContext() || {};
  const showToast = ctx.showToast;
  if (typeof showToast !== 'function') {
    throw new Error('useApToast : à utiliser sous AdminPersonnelLayout');
  }
  return {
    showToast,
    toast: ctx.toast || ((variant, msg) => showToast(msg, variant))
  };
}

export default useApToast;
